export enum TarafTypeEnum {
  FirstPartner = 1,
  SecondPartner = 2,
  Lawyer = 3,
}

export interface TarafTypeEnumDisplayNames {
  [key: number]: string;
}

export const TarafTypeEnumDisplayNames: TarafTypeEnumDisplayNames = {
  [TarafTypeEnum.FirstPartner]: 'طرف أول',
  [TarafTypeEnum.SecondPartner]: 'طرف ثاني',
  [TarafTypeEnum.Lawyer]: 'محامي',
};
